"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManualPauseItem = void 0;
const ui_1 = require("@app/component/ui");
const time_input_1 = require("@app/component/ui/input/time-input/time-input");
const util_1 = require("@app/util");
const use_debounce_1 = require("@app/util/forms/use-debounce");
const moment_1 = __importDefault(require("moment"));
const react_1 = __importDefault(require("react"));
const react_hook_form_1 = require("react-hook-form");
const shift_context_1 = require("../shift-context");
const ManualPauseItem = ({ index, field, update, error, }) => {
    const { formControl, disabledEditation } = (0, shift_context_1.useShift)();
    const period = (0, react_hook_form_1.useWatch)({ control: formControl, name: 'period' });
    const pauseStartOnChange = react_1.default.useCallback((startMinutes) => {
        update(index, {
            duration: field.duration,
            start: startMinutes,
        });
    }, [update, index, field.duration]);
    const { value: pauseStartValueDebounced, onChange: pauseStartOnChangeDebounced } = (0, use_debounce_1.useDebounce)({ onChange: pauseStartOnChange, ms: 750, value: field.start });
    const pauseDurationOnChange = react_1.default.useCallback((value) => {
        update(index, {
            duration: value,
            start: field.start,
        });
    }, [update, index, field.start]);
    const { value: pauseDurationValueDebounced, onChange: pauseDurationOnChangeDebounced, } = (0, use_debounce_1.useDebounce)({
        onChange: pauseDurationOnChange,
        ms: 750,
        value: field.duration,
    });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(ui_1.Input, { key: `${index}-pause-start`, type: 'time', size: 'full-width', label: (0, util_1.t)('PAUSE_START'), 
            // ico='clock'
            disabled: (0, util_1.isDefined)(disabledEditation), value: (0, moment_1.default)(period.start)
                .add(pauseStartValueDebounced, 'minutes')
                .format('HH:mm'), onChange: (val) => {
                const startMoment = (0, moment_1.default)((0, moment_1.default)(period.start)
                    .add(val >= (0, moment_1.default)(period.start).format('HH:mm') ? 0 : 1, 'days')
                    .format('YYYY-MM-DD') +
                    ' ' +
                    val, 'YYYY-MM-DD HH:mm');
                const startMinutes = (0, moment_1.default)(startMoment)
                    .startOf('minute')
                    .diff(period.start.startOf('minute'), 'minutes');
                pauseStartOnChangeDebounced(startMinutes);
            }, ...error }),
        react_1.default.createElement(time_input_1.TimeInput, { key: `${index}-pause-duration`, label: (0, util_1.t)('CYC_PRE_LENGTH'), maxHours: 24, disabled: (0, util_1.isDefined)(disabledEditation), onChange: pauseDurationOnChangeDebounced, value: pauseDurationValueDebounced, error: error?.hasError ? ' ' : undefined })));
};
exports.ManualPauseItem = ManualPauseItem;
